import { divideIntoShiftSlots } from './divideIntoShiftSlots.js';
import { isWorkShift } from './shifts.js';


export function getWorkTimeInPeriod(start: Date, end: Date): number {
    const shifts = divideIntoShiftSlots(start, end);
    const workShifts = shifts.filter(shift => isWorkShift(shift.start));

    const timeInPeriod = workShifts.reduce((total, shift) => {
        const workTime = shift.end.getTime() - shift.start.getTime();
        return total + workTime;
    }, 0);

    return timeInPeriod;
}
